<template>
	<li class="list-group-item cursor-pointer route-stop" :class="{ 'visited text-gray-500' : visit.checkin_id }" @click="toggleOpen()" data-test="routeStop">

		<div class="d-flex w-100">

			<div class="route-icon rounded-circle circle-cropped avatar-xs text-center font-weight-bold text-white mr-2">
				<i v-if="visit.checkin_id" class="far fa-check route-icon-label text-sm"></i>
				<span v-else class="route-icon-label">{{ String.fromCharCode('B'.charCodeAt() + index) }}</span>
			</div>

			<div class="flex-grow-1" :class="{'text-blue-700 font-weight-bold' : open}" data-test="routeStopName">
				{{ visitable.display_name }}
			</div>

			<div v-if="open" class="d-flex align-items-top leading-none text-xl-ish icons-wrapper">
				<a href="#" v-if="!visit.checkin_id" @click.stop="updateCheckinOptions()" data-test="routeStopAddCheckin">
					<i class="fal fa-check-circle mr-1 px-1 cursor-pointer text-gray-500" v-tooltip.bottom="'Create Check-in'" data-toggle="modal" data-target="#myModal"></i>
				</a>

				<a href="#" v-else @click.stop="showCheckin(visit.checkin_id)" data-test="routeStopShowCheckin">
					<i class="fal fa-check-circle mr-1 px-1 cursor-pointer text-gray-900" v-tooltip.bottom="'View Check-in'" data-toggle="modal" data-target="#checkinModal"></i>
				</a>

				<a @click.stop target="_blank" :href="'https://www.google.com/maps/dir/?api=1&dir_action=navigate&destination=' + destination" data-test="routeStopNavigate">
					<i class="fal fa-directions mr-1 px-1" :class="visit.checkin_id ? 'text-gray-300' : 'text-gray-500'" v-tooltip.bottom="'Navigate Here'"></i>
				</a>
				
				<router-link :to="{ name: visitable.model == 'App\\Group' ? 'groups.show' : 'physicians.show', params: { id: visitable.id } }" data-test="routeStopProfile">
					<i class="fal fa-user mr-1 px-1 text-gray-500" v-tooltip.bottom="'View Profile'"></i>
				</router-link>

				<div class="border-left pr-1 px-1" style="height:18px;"></div>

				<a href="#" v-if="!visit.checkin_id" @click="deleteRouteStop()" data-test="routeStopDelete">
					<i class="fal fa-map-marker-times cursor-pointer text-gray-500" v-tooltip.bottom="'Remove from Route'"></i>
				</a>
				<i v-else class="fal fa-map-marker-times text-gray-300"></i>
			</div>
		</div>

		<div v-if="open" class="ml-4 pl-1 mt-1 text-sm text-gray-600 leading-tight" v-html="visit.location.formatted_address" data-test="routeStopAddress">
		</div>
	</li>
</template>

<script>
	export default {
		props: ['visit', 'index', 'open_default'],

		data() {
			return {
				open: false,
			}
		},

		mounted() {
			this.open = this.open_default;
		},

		methods: {
			deleteRouteStop() {
				axios.delete(`/api/route-visits/${this.visit.id}`).then(({ data }) => {
                	//returns the route visits
                	this.$root.$emit('route_stops_changed', data);
                })		                					
			},

			showCheckin(checkin_id) {
				this.$root.$emit('show_checkin', checkin_id);
				
				//this bit of stupid is required since .stop modifier kills the modal load
				jQuery('#checkinModal').modal('show');				
			},

			toggleOpen() {
				this.open = !this.open;
			},

			updateCheckinOptions(event) {
				this.$root.$emit('update_checkin_options', {
					morphable_id : this.visitable.id,
					morphable_type : this.visitable.model,
					display_name : this.visitable.display_name,
					location_id  : this.visit.location.id,
				});

				//same as on showCheckin
				jQuery('#myModal').modal('show');
			},
		},

		computed: {
			destination() {
				var address = this.visit.location.address ? this.visit.location.address + ',' : ''; //simple null handling
				return encodeURIComponent(address + this.visit.location.city + ',' + this.visit.location.state);
			},
			visitable() {
				if (this.visit.physician && this.visit.physician.id) {
					return this.visit.physician;
				} else {
					return this.visit.group;
				}
			}
		}
	}

</script>

<style scoped>
	.icons-wrapper {
		margin-right:-.5rem;
	}

	.text-xl-ish {
		font-size:1.2rem;
	}
</style>